import { ReportListItemData } from './report-base';

export class CreditCardExpireReportData extends ReportListItemData {
  usercardID: number;
  maskedccnum: string;
  cardtype: string;
  expdate: string;
  paymentID: number;
}

export class CCExpiredReport {
  totalNumberOfExpiredCard: number;
  totalNumberOfAboutToExpire: number;
  list: CreditCardExpireReportData[];

  constructor(data: any = {}) {
    this.totalNumberOfExpiredCard = +data.totalNumberOfExpiredCard;
    this.totalNumberOfAboutToExpire = +data.totalNumberOfAboutToExpire;
    this.list = data.ccExpireReportUserList ? data.ccExpireReportUserList.map(l => new CreditCardExpireReportData(l)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/expired-credit-card-report.ts